import React from 'react';
import { Phone, Smartphone, Mail } from 'lucide-react';

const Contatti = () => {
  const primaryColor = "#232D3B";

  return (
    <section id="contatti" className="py-8 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold mb-2" style={{ color: primaryColor }}>Contattaci</h2>
          <p className="text-gray-600 text-sm max-w-xl mx-auto">
            I nostri uffici sono aperti dal lunedì al venerdì dalle 8:30 alle 12:30 e dalle 14:00 alle 18:00, il sabato dalle 8:30 alle 12:30.
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Telefono Ufficio */}
          <div className="bg-white p-6 rounded-lg shadow-sm text-center hover:shadow-md transition-shadow duration-300">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4" style={{ backgroundColor: `${primaryColor}10` }}>
              <Phone size={20} style={{ color: primaryColor }} />
            </div>
            <h3 className="text-lg font-semibold mb-2" style={{ color: primaryColor }}>Telefono</h3>
            <a href="tel:+390307998505" className="text-gray-600 hover:text-gray-900 transition-colors block">
              +39 0307998505
            </a>
          </div>

          {/* Cellulare */}
          <div className="bg-white p-6 rounded-lg shadow-sm text-center hover:shadow-md transition-shadow duration-300">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4" style={{ backgroundColor: `${primaryColor}10` }}>
              <Smartphone size={20} style={{ color: primaryColor }} />
            </div>
            <h3 className="text-lg font-semibold mb-2" style={{ color: primaryColor }}>Cellulare</h3>
            <a href="tel:+393482920338" className="text-gray-600 hover:text-gray-900 transition-colors block">
              +39 3482920338
            </a>
          </div>

          {/* Email */}
          <div className="bg-white p-6 rounded-lg shadow-sm text-center hover:shadow-md transition-shadow duration-300">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4" style={{ backgroundColor: `${primaryColor}10` }}>
              <Mail size={20} style={{ color: primaryColor }} />
            </div>
            <h3 className="text-lg font-semibold mb-2" style={{ color: primaryColor }}>Email</h3>
            <a href="mailto:info@masmetalsrl.com" className="text-gray-600 hover:text-gray-900 transition-colors block">
              info@masmetalsrl.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contatti;